/**
 * D'où vient l'impersonation en cours (#150).
 *
 * Pendant une impersonation, le payload porte le rôle de la CIBLE et seulement
 * l'`impersonatorId` de l'usurpateur : rien ne dit si celui-ci est un admin de
 * l'org ou un opérateur plateforme. Or la sortie en échec ne mène pas au même
 * logout — le super-admin n'a pas d'org, son écran de connexion est celui de
 * `/o/_system`.
 *
 * L'opérateur plateforme change de basename par un rechargement complet de
 * page : le store en mémoire est perdu, d'où `sessionStorage` (propre à
 * l'onglet, effacé à sa fermeture).
 */
const KEY = 'studeva.impersonation.origin'
const PLATFORM = 'platform'

/** À poser quand un opérateur plateforme entre dans une organisation. */
export function markPlatformImpersonation(): void {
  try {
    sessionStorage.setItem(KEY, PLATFORM)
  } catch {
    // stockage indisponible : la sortie retombera sur le logout de l'org
  }
}

/** L'usurpateur est-il un opérateur plateforme ? */
export function isPlatformImpersonation(): boolean {
  try {
    return sessionStorage.getItem(KEY) === PLATFORM
  } catch {
    return false
  }
}

/** À appeler dès que l'impersonation prend fin, réussie ou non. */
export function clearImpersonationOrigin(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // rien à nettoyer
  }
}
